// Türkçe karakter kontrolü
export const isTurkishText = (text) => {
  if (!text) return false;
  // Türkçe özel karakterler
  const turkishChars = /[çÇğĞıİöÖşŞüÜ]/;
  // Türkçe yaygın kelimeler
  const turkishWords = /\b(ve|bir|bu|ne|için|ile|da|de|mi|mı|mu|mü|ama|çok|var|yok|daha|gibi|kadar|olan|olarak|ben|sen|biz|siz|onlar|olan|olur|değil|eder|yapar|gelir|gider|ise|ki|bile|hep|hiç)\b/i;
  return turkishChars.test(text) || turkishWords.test(text);
};

// Otomatik dil algılama ile TTS fonksiyonu
export const speakText = (text) => {
  if (!text || typeof text !== 'string') return false;
  
  if ('speechSynthesis' in window) {
    try {
      window.speechSynthesis.cancel(); // Önceki okumayı durdur
      const utterance = new SpeechSynthesisUtterance(text);
      
      // Metne göre dil seç
      if (isTurkishText(text)) {
        utterance.lang = 'tr-TR';
        utterance.rate = 0.95; // Türkçe için biraz daha yavaş
      } else {
        utterance.lang = 'en-US';
        utterance.rate = 0.9;
      }
      
      window.speechSynthesis.speak(utterance);
      return true;
    } catch (e) {
      console.log('TTS hatası:', e);
      return false;
    }
  }
  return false;
};

// Sadece İngilizce metinleri okuyan TTS fonksiyonu (eski uyumluluk için)
export const speakEnglishOnly = (text) => {
  if (isTurkishText(text)) {
    return false;
  }
  return speakText(text);
};

export default { isTurkishText, speakText, speakEnglishOnly };
